import { render, staticRenderFns } from "./Solicitud.vue?vue&type=template&id=25c623d0"
import script from "./Solicitud.vue?vue&type=script&lang=js"
export * from "./Solicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports